import {
  EngineReportDetails,
  SWASH_PLATE_COUNT,
  SwashPlatePositionVm,
} from '@navstation-portal/reporting/data-model/engine-report';
import { Units } from '@navstation-portal/shared/data-model/ui';
import { getHardValidation } from '../range-tooltip.utils';

const SWASH_PLATE_LIMITS = { min: 0, max: 100 } as const;
const SUBJECT = 'Swash Plate Position';

export function buildSwashPlatePositionVm(details: EngineReportDetails | undefined): SwashPlatePositionVm {
  return {
    swashPlateValidations: Array.from({ length: SWASH_PLATE_COUNT }, (_, index) =>
      getHardValidation(details?.swashPlates?.[index], SWASH_PLATE_LIMITS, SUBJECT, Units.percent)
    ),
  };
}
